module.exports = __webpack_public_path__ + "img/indent.b8408d3c.svg";